export default __webpack_public_path__ + "static/media/logo2.de48328b.png";